// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Collapse: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<polygon points="4.67,14 9.1,14 0.3,22.8 1.2,23.7 10,14.9 10,19.33 11.26,19.33 11.26,12.74 4.67,12.74 "/>
<polygon points="23.7,1.2 22.8,0.3 14,9.1 14,4.67 12.74,4.67 12.74,11.26 19.33,11.26 19.33,10 14.9,10 "/>
</svg>;
};

export default React.memo(Collapse);
